import { useAtomValue } from 'jotai';
import { $HashtagPopularPost, $HashtagRecentPost } from 'shared/atoms';
import { $RootTraffic, $Locale } from '@lemon8/web-app-shared/atom';
import { useHashtagDesc } from '../shared/use-hashtag-desc';
import { $CurrentAvailableHashtagInfoOrNull, $CurrentHashtagId } from '~/routes/topic.$hashtag_id/shared/atoms';
import { FC } from 'react';

export const OG: FC = () => {
  const defaultArticleItem = {
    largeImage: {
      url: '',
    },
  };
  const { enterHref: href } = useAtomValue($RootTraffic);
  const { region } = useAtomValue($Locale);
  const hashtagId = useAtomValue($CurrentHashtagId);
  const hashtag = useAtomValue($CurrentAvailableHashtagInfoOrNull);
  const { items: popularPostItems } = useAtomValue($HashtagPopularPost(hashtagId));
  const { items: recentPostItems } = useAtomValue($HashtagRecentPost(hashtagId));
  const description = useHashtagDesc();

  if (!hashtag) {
    return null;
  }

  const { name } = hashtag;

  const ogUrl = (href && `${href.split('?')[0]}?region=${region}`) || '';

  let firstArticle = defaultArticleItem;

  if (popularPostItems.length > 0) {
    firstArticle = popularPostItems[0];
  } else if (recentPostItems.length > 0) {
    firstArticle = recentPostItems[0];
  } else {
    firstArticle = defaultArticleItem;
  }

  const { largeImage } = firstArticle;
  const { url: imgUrl = '' } = largeImage;

  return (
    <>
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={name} />
      <meta property="og:description" content={description} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image" content={imgUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={name} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imgUrl} />
    </>
  );
};
